import { Component, Input, OnInit } from '@angular/core';
import { RoadTypeReportReportLineView } from 'src/app/reports/_models/view/roadTypeReportView';
import {
  SegmentLine,
  SummaryLine,
  TollReport,
} from 'src/app/_models/pcmws/reports/tollReportResponse';
import { RouteState } from 'src/app/_models/state/routeState';

@Component({
  selector: 'app-toll-type-report',
  templateUrl: './toll-type-report.component.html',
  styleUrls: ['./toll-type-report.component.scss'],
})
export class TollTypeReportComponent implements OnInit {
  @Input() route: RouteState;
  tollTypeReports: TollReport;
  segmentLines: SegmentLine[];
  summaryLines: SummaryLine[];
  roadTypeStopsCount: number;
  total: number;

  ngOnInit(): void {
    this.segmentLines = this.route?.tollReport?.SegmentLines;
    this.summaryLines = this.route?.tollReport?.SummaryLines;
    if (this.summaryLines?.length > 0) {
      this.total = this.summaryLines
        .filter(
          (summaryLine) =>
            summaryLine.TollType !== 'Vignettes' && summaryLine.Tolls !== ''
        )
        .map((a) => parseFloat(a.Tolls))
        .reduce((a, b) => a + b);
    }
  }
}
